'use client';

import { c as _c } from "react/compiler-runtime";
import { CommentSection } from './CommentSection';
interface ActivityFeedProps {
  objectId: string;
  objectType: 'item' | 'collection' | 'entity' | 'collection_item' | 'content' | 'initiative';
  canComment?: boolean;
}
export function ActivityFeed(t0) {
  const $ = _c(4);
  const {
    objectId,
    objectType,
    canComment: t1
  } = t0;
  const canComment = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== canComment || $[1] !== objectId || $[2] !== objectType) {
    t2 = <div className="space-y-8"><CommentSection objectId={objectId} objectType={objectType} canComment={canComment} /></div>;
    $[0] = canComment;
    $[1] = objectId;
    $[2] = objectType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}